import { Component, inject, OnInit } from '@angular/core';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatTooltipDefaultOptions,
} from '@angular/material/tooltip';
import { routeOuterAnimations } from './shared/animations/allAnimations';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from './shared/Theme/services/theme.service';
import { HttpClient } from '@angular/common/http';
import { Auth, authState } from '@angular/fire/auth';
import { environment } from 'src/environments/environment';
/** Custom options the configure the tooltip's default show/hide delays. */
export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  position: 'above',
  showDelay: 0,
  hideDelay: 0,
  touchendHideDelay: 0,
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults },
  ],
  animations: [routeOuterAnimations],
})
export class AppComponent implements OnInit {
  title = 'ExitAnalysis';
  constructor(private auth:Auth) { }
  currentIndex: number = -3;
  value
  private readonly http = inject(HttpClient);


ngOnInit(): void {

}


  resolveRoute(o: RouterOutlet) {
    let path = o.activatedRouteData['animation'];
    if (o.isActivated) {
      if (path > this.currentIndex) {
        this.value = 'down';
      } else if (path < this.currentIndex) {
        this.value = 'up';
      }

      this.currentIndex = path;
      return this.value;
    }
  }


}
